import React, {Component} from 'react';
import * as api from '../../../api/analytics-api';
import Cookies from 'universal-cookie';
import CustomChart from './CustomChart';
import {selectedSiteId} from '../../../store';
import i18next from 'i18next';
import {connect} from 'react-redux';
import ErrorBox from '../../utils/ErrorBox';
import PropTypes from 'prop-types';
import ChartsQueryTimeSelector from '../../utils/ChartsQueryTimeSelector';
import * as blockUtils from '../../../utils/BlockUtils';

const TERMINAL_COOKIE_KEY = 'analytics-terminalId';
const QUERY_TIME_COOKIE_KEY = 'analytics-chartsQueryTime';
const cookies = new Cookies();

class TerminalKpi extends Component {
  constructor(props) {
    super(props);

    this.getTerminalKpis = this.getTerminalKpis.bind(this);

    this.state = {
      chartsViews: [],
      kpiOptions: {},
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.siteId !== prevProps.siteId) {
      this.getTerminalKpis();
    }
  }

  componentDidMount() {
    this.getTerminalKpis();
  }

  getTerminalKpis() {
    const siteId = this.props.siteId;
    const terminalId = cookies.get(TERMINAL_COOKIE_KEY);
    const queryTime = cookies.get(QUERY_TIME_COOKIE_KEY);

    if (!siteId || !terminalId || siteId === -1) {
      return;
    }

    this.setState({
      chartsView: [],
      kpiOptions: {},
    });

    blockUtils.blockUI();
    api.getTerminalKpis(siteId, terminalId, queryTime).then((chartsResponse) => {
      this.setState({
        chartsView: chartsResponse.data.charts,
        kpiOptions: chartsResponse.data.kpiOptions,
      });
      blockUtils.unblockUI();
    }).catch((error) => {
      this.setState({
        noSiteSelectedError: this.getErrorMessage(error, siteId),
      });
      blockUtils.unblockUI();
    });
  }

  getErrorMessage(error, chosenSite) {
    if (error.response.status === 404) {
      return 'No data found for the given site with ID ' + chosenSite;
    } else if (error.response.status === 504) {
      return 'Request to Häfele API for site with ID [' + chosenSite + '] timed out. Please try again';
    }

    return error.message;
  }

  render() {
    return (
      <div>
        {this.props.noSiteSelectedError && this.props.noSiteSelectedError !== '' ?
          <ErrorBox
            errorMessage={this.props.noSiteSelectedError}
          /> :

          <div>
            <ChartsQueryTimeSelector showTerminals={true} onTimeChange={this.getTerminalKpis} />
            <CustomChart
              kpiOptions={this.state.kpiOptions || {}}
              chartViews={this.state.chartsView || []}
            />
          </div>
        }
      </div>
    );
  }
}

TerminalKpi.propTypes = {
  noSiteSelectedError: PropTypes.string,
  siteId: PropTypes.number,
};

const mapStateToProps = function(store) {
  const currentSiteId = store.sitesState.currentSiteId === -1 ? selectedSiteId() : store.sitesState.currentSiteId;
  const selectSiteMessage = currentSiteId === -1 ? i18next.t('terminals.errors.select_site') : '';
  return {
    siteId: currentSiteId,
    noSiteSelectedError: selectSiteMessage,
  };
};

export default connect(mapStateToProps)(TerminalKpi);
